import React from 'react';
import { Box, Text, HStack, Button, Image } from '@chakra-ui/react';

const Header = () => {
  return (
    <Box
      w="full"
      h={['100vh', '100vh']}
    >
      <Box
        w="100%"
        p={['1.75rem', '2rem', '2rem', '6rem']}
        display="flex"
        flexDirection={['column', 'row']}
        alignItems="center"
        justifyContent="space-between"
        bg="#fff"
      >
        <Box w={['100%', '50%', '50%', '50%']} float="right" pl="1.5rem">
          <Text
            fontSize={['1.8rem', '2.5rem', '2.5rem', '3rem']}
            // noOfLines='2'
            fontFamily='Duplicate Sans'
            color="#1F1F29"
            mt="1rem"
            fontWeight="500"
          >
            Accept payment with
simple scan and pay
          </Text>
          <Text
            fontSize={['.75rem', '1rem']}
            lineHeight="28px"
            mt="1rem"
            fontFamily='Work Sans'
            color="#445368"
          >
            Don’t just get paid, withdraw your funds easily from your account
            with just your biometric
          </Text>
          <HStack mt="1rem" gap={['4', '2', '2', '2']}>
          <Button
              href="#services"
              _hover={{ textDecoration: 'none' }}
              textAlign="center"
              fontFamily='Work Sans'
              fontSize={['.75rem', '1rem', '.7rem', '1rem']}
              color="#fff"
              bg="#246BFD"
              w={['120px','160px']} h={['44px','54px']}
              p={['.75rem 1.5rem', ' 16px, 24px, 16px, 24px']}
              borderRadius="8px"
              fontWeight="500"
              _active={{ color: '#000' }}
            >
              Get Started&nbsp;{' '}
              <Image
                src="/hero_arrow.png"
                _hover={{ marginLeft: '.2rem' }}
                alt="socials"
              />
            </Button>
            
          </HStack>
        </Box>
        <Box w={['100%', '50%', '50%', '50%']}>
          <Image
            m="auto"
            w=""
            h="100%"
            src="/QR.png"
            alt="mobile"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
